import { ColumnAccessorSortable } from '@/types/columns';
import { atom } from 'jotai';

/**
 * Column IDs that the user has chosen to hide in the table.
 * Used together with business visibility: a column is shown only if
 * it is business-visible and not in this list.
 */
export const hiddenSortableColumnsState = atom<ColumnAccessorSortable[]>([]);
